import { useQuery } from "@tanstack/react-query";
import { getShortlistProjects } from "../api/shortlist-report-api";
import type { ShortlistProject } from "../api/shortlist-report-api";

export const useShortlistProjects = () => {
	return useQuery<ShortlistProject[]>({
		queryKey: ["shortlist-projects"],
		queryFn: getShortlistProjects,
		staleTime: 5 * 60 * 1000,
	});
};
